<template>
  <div class="teacher_page flex1 h100" style="padding: 50px 0 60px 0">
    <DashHeader
      v-if="session"
      :share="copyUrl"
      :openEvaluate="openEvaluate"
      :showStudents="showStudents"
      :reopenClass="_reopenClass"
      :turnModel="turnModel"
      :confirmModeChange="confirmModeChange" />
    <!-- Flex wrapper for content + embedded meeting sidebar -->
    <div style="display: flex; flex: 1; height: 100%; overflow: hidden">
      <div v-if="cpaDrawUrl" class="content" style="position: relative; width: 100%; height: 100%; background: #fff; display: flex; flex-direction: column">
        <!-- Multi-Student Whiteboard Switcher Tabs -->
        <div
          v-if="cpaDrawUrl"
          class="teacher-wb-tabs-bar"
          :style="{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            marginTop: Math.max(28, ((dashHeaderHeight || 74) - 50 + 6)) + 'px',
            padding: '8px 16px',
            background: '#f8fafc',
            borderBottom: '1px solid #e2e8f0',
            flexShrink: 0,
            zIndex: 10,
          }">
          <div style="display: flex; align-items: center; gap: 6px; margin-right: 8px; color: #475569; font-size: 13px; font-weight: 600">
            <i class="el-icon-folder-opened" style="font-size: 15px; color: #0284c7"></i>
            <span>Student Whiteboards:</span>
          </div>

          <div
            v-for="st in (channelStudents && channelStudents.length ? channelStudents : [{ identity: activeWhiteboardStudentIdentity || 'active', name: 'Current Student', cpaDrawUrl }])"
            :key="st.identity"
            @click="selectWhiteboardTab(st)"
            :style="{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '6px 14px',
              borderRadius: '6px',
              fontSize: '13px',
              fontWeight: activeWhiteboardStudentIdentity === st.identity ? '600' : '500',
              cursor: 'pointer',
              background: activeWhiteboardStudentIdentity === st.identity ? '#ffffff' : '#f1f5f9',
              color: activeWhiteboardStudentIdentity === st.identity ? '#0284c7' : '#64748b',
              boxShadow: activeWhiteboardStudentIdentity === st.identity ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
              border: activeWhiteboardStudentIdentity === st.identity ? '1.5px solid #0284c7' : '1px solid #cbd5e1',
              transition: 'all 0.15s ease',
            }">
            <i :class="activeWhiteboardStudentIdentity === st.identity ? 'el-icon-edit' : 'el-icon-user'"></i>
            <span>{{ st.name || st.identity }}</span>
            <span
              v-if="activeWhiteboardStudentIdentity === st.identity"
              style="font-size: 10px; background: #e0f2fe; color: #0369a1; padding: 2px 6px; border-radius: 10px; font-weight: 700; text-transform: uppercase">
              Active
            </span>
          </div>
        </div>

        <div style="flex: 1; width: 100%; height: 100%; position: relative">
          <iframe :key="cpaDrawUrlKey" :src="cpaDrawUrl" frameborder="0" style="width: 100%; height: 100%; border: none" tabindex="-1"></iframe>
        </div>
      </div>
      <template v-else-if="!questionModalVisiable">
        <!--For video content classroom-->
        <div v-if="session?.video && !session.videoSlide" class="content">
          <VideoPlayer
            v-if="Array.isArray(session.video)"
            :video="session.video[0]"
            :getResponeCount="getResponeCount"
            :responseContentList="responseContentList" />
          <VideoPlayer v-else :video="session.video" :getResponeCount="getResponeCount" :responseContentList="responseContentList" />
        </div>

        <!--else part for video-->
        <div v-else-if="getPage.type === 'video'" class="content">
          <div v-if="!showVideoPlayer" class="popup-overlay">
            <div class="popup-box">
              <div v-if="$route.name === 't'">
                <h3>Please play this video using the Classroom Dashboard View</h3>
              </div>
              <div v-else>
                <h3>You are going to an interactive video environment</h3>
                <button class="watch-btn" @click="watchVideoClicked">Watch Video</button>
              </div>
            </div>
          </div>
          <VideoPlayer
            v-if="showVideoPlayer && videoData"
            :getPage="getPage"
            :video="videoData"
            :getResponeCount="getResponeCount"
            :responseContentList="responseContentList"
            @closeVideoPlayer="closeVideoPlayer"
            :isPpt="true" />
          <div v-if="!showVideoPlayer">
            <DashboardPage
              v-if="isDashboard"
              :currentAnswerCount="currentAnswerCount"
              :responseContentList="responseContentList"
              :responsePercentage="responsePercentage"
              :meterialVisiable="isMaterialShow"
              :overviewModalVisiable="overviewModalVisiable"
              :changePage="pageChange"
              :session="session"
              :getResponeCount="getResponeCount" />
          </div>
        </div>
        <div v-else class="content">
          <TeacherPPTPage
            v-if="!isDashboard"
            :currentAnswerCount="currentAnswerCount"
            :responseContentList="responseContentList"
            :meterialVisiable="isMaterialShow" />
          <DashboardPage
            v-if="isDashboard"
            :currentAnswerCount="currentAnswerCount"
            :responseContentList="responseContentList"
            :responsePercentage="responsePercentage"
            :meterialVisiable="isMaterialShow"
            :overviewModalVisiable="overviewModalVisiable"
            :changePage="pageChange"
            :session="session"
            :getResponeCount="getResponeCount" />
        </div>
        <div class="control">
          <!--
          isVideoClassroom prop is added to manipulate the options
        -->
          <teacherControlPanel
            v-if="session"
            :isVideoClassroom="session?.video && !session.videoSlide ? true : false"
            :currentPage="parseInt(currentPageIndex) + 1"
            :isDashboard="isDashboard"
            :changePage="pageChange"
            :turnModel="turnModel"
            :current_response="currentAnswerCount"
            :isClosed="session.status == 'close'"
            :reopenClass="_reopenClass"
            :meterialVisiable="isMaterialShow"
            :showDashTips="showDashTips"
            :showNewPrompt="showNewPrompt"
            :dashTipsModalVisiable="dashTipsModalVisiable"
            :getPage="getPage" />
        </div>
      </template>
    </div>
    <!-- end flex wrapper -->

    <guidePrompt v-if="isInitOk" :isDashboard="isDashboard" :guideOkCall="guideOkCall" />

    <CommentModal />

    <el-dialog title="Set feedback failure" :visible.sync="showTimeSetDialog">
      <feedbackTimePanel :mode="mode" :changeFeedbackTimeMode="changeFeedbackTimeMode" />
    </el-dialog>

    <el-dialog title="" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false" :visible.sync="cancelled" :append-to-body="true">
      <div class="dialog_page">
        <div>This session has been cancelled, please schedule another workshop</div>
        <div class="flex_r pd_t1">
          <el-button type="danger" @click="backToClass()">Confirm</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      v-if="isInitOk && isGuideOk && (session.welcome || showShareEvenClose)"
      title="Join at classcipe.com"
      @close="closeCopyDialog"
      :visible="session.welcome || showShareEvenClose"
      :center="true"
      custom-class="custom-dialog"
      top="2vh"
      width="90vw">
      <AnonymousLogin :closeLoginModal="closeCopyDialog" />
    </el-dialog>

    <el-dialog
      title="Reopen session"
      @close="closeReopenDialog"
      v-if="showReopenDialog"
      :visible="showReopenDialog"
      :center="true"
      custom-class="custom-dialog"
      top="2vh"
      width="700px">
      <ReopenDialog :close="closeReopenDialog" />
    </el-dialog>

    <el-drawer :with-header="false" :visible.sync="showClassroomRoster" direction="ltr" size="90%" custom-class="classroom-roster-drawer">
      <!--
      <classroom-roster :openEvaluate="openEvaluate" v-show="showClassroomRoster" v-if="isGuideOk" @close="showClassroomRoster = false" />
      -->
      <classroom-roster :openEvaluate="openEvaluate" v-show="showClassroomRoster" @close="showClassroomRoster = false" />
    </el-drawer>

    <!--
    <studentAudioItem class="flex1" v-else-if="getQuestion.type === 'media'" v-bind="$attrs" :addMediaAnswer="addMediaAnswer" />
    <el-dialog :visible.sync="showNewPromptDialog" fullscreen>
      <new-prompt-page style="height: 900px" :addPPTItem="addPPTItem" :closeBtn="closeNewPrompt" />
    </el-dialog>
    -->
    <new-prompt-page
      v-if="showNewPromptDialog"
      class="flex1"
      :currentPage="parseInt(currentPageIndex) + 1"
      :addPPTItem="addPPTItem"
      :closeBtn="closeNewPrompt" />
    <el-dialog :visible.sync="showStudentPacedNotePage" :show-close="false" :close-on-click-modal="false" width="80%">
      <ModalStudentModeOn v-if="showStudentPacedNotePage" :confirmModeChange="confirmModeChange" :cancelModeChange="cancelModeChange" />
    </el-dialog>

    <el-drawer direction="ltr" :visible.sync="dashTipsModalVisiable" size="90%" :withHeader="false">
      <!-- <el-dialog :visible.sync="dashTipsModalVisiable" width="80%"> -->
      <dashTipsModal :close="showDashTips" :isTeacher="true" />
      <!-- </el-dialog> -->
    </el-drawer>

    <bigPreview :isShowResponse="showResponse" />
    <preview-metarial-item :meterialVisiable="isMaterialShow" />

    <el-drawer :destroy-on-close="true" size="95%" :visible.sync="drawerEvaluate" direction="ltr" :withHeader="false" :wrapperClosable="false">
      <el-button icon="el-icon-close" style="position: absolute; top: 1rem; right: -1.5rem; z-index: 1000" circle @click="closeEvaluate"></el-button>
      <iframe class="flex1" style="margin: 0" :src="evaluationUrl" frameborder="0"></iframe>
    </el-drawer>
    <DrawBox v-if="($route.name === 'd' && !syncUI.fullPlayOn) || $route.name === 't'" />
    <fullPlay v-if="($route.name === 'd' && !syncUI.fullPlayOn) || $route.name === 't'" />
    <remotePlay v-if="$route.name === 'd' && syncUI.fullPlayOn === 'projector'" />
    <fullIframe />
    <fullDoc />
    <!-- <drawTop v-if="isGuideOk && syncUI.drawUrl" /> -->
  </div>
</template>

<script>
import copy from 'copy-to-clipboard'
// import drawTop from '@/components/drawTop.vue'
import {getStore} from '@/utils/localStore'
import {showLoading, hideLoading, showToast} from '../utils/loading'
import fullPlay from '@/components/fullPlay.vue'
import DrawBox from '@/components/DrawBox.vue'
import fullIframe from '@/components/fullIframe.vue'
import fullDoc from '@/components/fullDoc.vue'
import remotePlay from '@/components/common/remotePlay.vue'
import teacherControlPanel from '../components/teacher/teacherControlPanel'
import CommentModal from '@/components/teacher/commentModal.vue'
import TeacherPPTPage from '@/components/teacher/teacherPPTPage.vue'
import DashboardPage from '@/components/teacher/dashboardPage.vue'
import feedbackTimePanel from '../components/teacher/feedbackTimePanel'
import AnonymousLogin from '../components/teacher/AnonymousLogin.vue'
import ReopenDialog from '../components/teacher/ReopenDialog.vue'
import dashCopyDialog from '../components/teacher/dashCopyDialog'
import StudentsQsModal from '@/components/teacher/studentsQsModal.vue'
import guidePrompt from '@/components/guidePrompt.vue'
import DashHeader from '@/components/teacher/dashHeader.vue'
import dashTipsModal from '@/components/teacher/dashTipsModalV3.vue'
import {mapActions, mapState, mapMutations, mapGetters} from 'vuex'
import NewPromptPage from '@/components/teacher/newPromptPage.vue'
import bigPreview from '@/components/common/bigPreview.vue'
import ClassroomRoster from '@/components/teacher/ClassroomRoster'
import PreviewMetarialItem from '@/components/drag/previewMetarialItem.vue'
import VideoPlayer from '@/components/teacher/interactive-video/VideoPlayer.vue'
import ModalStudentModeOn from '@/components/teacher/modals/StudentModeOn.vue'

export default {
  components: {
    guidePrompt,
    ClassroomRoster,
    teacherControlPanel,
    CommentModal,
    TeacherPPTPage,
    DashboardPage,
    // welcomeModal,
    feedbackTimePanel,
    AnonymousLogin,
    ReopenDialog,
    StudentsQsModal,
    DashHeader,
    dashCopyDialog,
    dashTipsModal,
    NewPromptPage,
    bigPreview,
    PreviewMetarialItem,
    DrawBox,
    fullPlay,
    remotePlay,
    fullIframe,
    fullDoc,
    // drawTop,
    ModalStudentModeOn,
    VideoPlayer,
  },
  data() {
    return {
      isInitOk: false,
      rosterLoading: false,
      studentCounts: 0,
      currentSo: null,
      currentAnswerCount: 0,
      cancelled: false,
      name: '',
      googleLoginStatus: 0, // 0 未知， -1 登录， 1 登录
      responseContentList: [],
      token: '',
      isLocked: false,
      isDashboard: false,
      responsePercentage: [],
      isFocus: [],
      welcomeModalVis: false,
      welcomeModalShowed: false,
      showTimeSetDialog: false,
      copyLinkBtnString: '',
      firstCloseCopyLinkDialog: true,
      mode: 1,
      questionModalVisiable: false,
      markupslist: [], // ppt comment列表
      overviewModalVisiable: false,
      dashTipsModalVisiable: false,
      showNewPromptDialog: false,
      showReopenDialog: false,
      inputDialog: false,
      sendControlDelay: null,
      showClassroomRoster: false,
      showNetErrorDelay: null,
      drawerEvaluate: false,
      evaluationUrl: '',
      showShareEvenClose: false,

      // turn mode modal
      showStudentPacedNotePage: false,
      isGuideOk: false,

      showVideoPlayer: false,
      videoData: null,
      cpaDrawUrl: '',
      cpaDrawKey: 0,
      channelStudents: [],
      activeWhiteboardStudentIdentity: '',
      dashHeaderHeight: 74,
    }
  },
  created() {
    window._this = this
    window._state = this.$store.state
    window._store = this.$store
    this.$store.commit('setClassId', {id: this.$route.params.id, name: this.$route.name})
  },
  async mounted() {
    localStorage.setItem('referrer', document.referrer)
    window._st = Date.now()
    window.classId = this.class_id
    this.isDashboard = this.$route.name === 'd'
    this.token = this.$route.query.token || (await App.authentication.getAccessToken()) || ''
    await this.$store.dispatch('getClassInfo')
    App.service('session').removeAllListeners(['patched', 'removed'])
    App.service('session')
      .on('patched', (rs) => {
        commit('patchSession', rs)
      })
      .on('removed', (rs) => {
        if (rs.sid === this.session.sid) {
          this.cancelled = true
        }
      })
    const {commit} = this.$store
    App.service('response').removeAllListeners(['created', 'patched', 'removed'])
    App.service('response')
      .on('created', (rs) => {
        commit('student/setAllAnswerdListOne', rs)
      })
      .on('patched', (rs) => {
        commit('student/setAllAnswerdListOne', rs)
      })
      .on('removed', (rs) => {
        commit('student/deleteOnAnswerById', rs._id)
      })
    App.service('auth').removeAllListeners(['patched'])
    App.service('auth').on('patched', (rs) => {
      const {id, on, from, user, role} = rs
      if (id === 'syncUI') return commit('setSyncUI', rs, {root: true})
      if (user) {
        const online = on === 'connect' ? true : false
        if (role === 'teacher') return commit('teacher/setTeacher', user), commit('teacher/setOnlineTeacher', [[user._id], online])
        commit('teacher/setOnlineList', [[user._id], online])
        return
      }
      if (this.$route.name === 'p' && this.isStudentPaced) return
      try {
        if (rs.emit) EventBus.$emit(rs.emit, rs.data)
        if (rs.method && this[rs.method]) this[rs.method](rs.data)
        if (rs.commit) commit(rs.commit, rs.data)
      } catch (error) {}
    })
    if (!this.session?._id) {
      this.cancelled = true
      hideLoading()
      return
    }
    await this.initWithToken()
    await this.$store.dispatch('getClassInfo')
    if (this.$route.query.reopen) this._reopenClass() // 重开课堂通知
    window.teachers = this.teachers
    window.groups = this.groups
    if (!this.session.drawkey) {
      let drawkey = await Fn.drawKey()
      await this.$store.dispatch('upSession', {drawkey})
    }
    await this.$store.dispatch('getClassDetail')
    await this.$store.dispatch('getTakeaway')

    // Mandatory class meeting — auto-start for teacher
    if (this.session && this.session.sid) {
      localStorage.setItem('meeting_active_' + this.session.sid, 'true')
      this.$store.commit('setMeeting', {
        active: true,
        minimized: false,
        name: this.user?.nickname || this.user?.name || 'Teacher',
        sid: this.session.sid,
        sessionId: this.session._id,
        audioMuted: true,
        videoMuted: true,
        isTeacher: true,
      })
      this.$store.dispatch('upSession', {lastMeetingHeartbeat: Date.now()}).catch(() => {})
    }

    if (window.EventBus) {
      EventBus.$on('accepted-student-help', this.handleAcceptedStudentHelp)
      EventBus.$on('left-student-help', this.handleTeacherLeaveHelp)
      EventBus.$on('teacher-left-help', this.handleTeacherLeaveHelp)
      EventBus.$on('channel-students-updated', this.handleChannelStudentsUpdated)
    }

    this.measureDashHeader()
    window.addEventListener('resize', this.measureDashHeader)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.measureDashHeader)
    if (window.EventBus) {
      EventBus.$off('accepted-student-help', this.handleAcceptedStudentHelp)
      EventBus.$off('left-student-help', this.handleTeacherLeaveHelp)
      EventBus.$off('teacher-left-help', this.handleTeacherLeaveHelp)
      EventBus.$off('channel-students-updated', this.handleChannelStudentsUpdated)
    }
  },
  computed: {
    ...mapState(['session', 'class_id', 'syncUI', 'meeting', 'user']),
    ...mapState('student', ['currentPageIndex']),
    ...mapState('teacher', ['students', 'classStudents', 'rooms', 'teachers', 'groups']),
    ...mapGetters(['getPage', 'getPageId', 'getPageNum', 'getQuestion', 'isMaterialShow', 'isStudentPaced', 'isMentorOrSubstitute']),

    showResponse() {
      return this.$store.getters['teacher/isResponseShow'](this.currentPageIndex)
    },
    cpaDrawUrlKey() {
      return (this.cpaDrawUrl || '') + '_' + (this.cpaDrawKey || 0)
    },
  },
  watch: {
    currentPageIndex() {
      this.getPageData()
      if (!this.isInitOk) return 0
    },
  },
  beforeRouteEnter(to, from, next) {
    window.isTeacherPage = true
    next((vm) => {})
  },
  methods: {
    ...mapMutations('teacher', ['hidePageMaterial']),
    ...mapActions('teacher', ['initStudent', 'setFeedBackList', 'setFeedBackAnswerIds']),
    ...mapActions('student', ['setStudentPageIndex', 'setAllAnswerdList']),
    isCpaQuestion(slide) {
      if (!slide) return false
      if (typeof slide === 'object') {
        if (slide.hasOwnProperty('isCpa')) return !!slide.isCpa
        if (slide.cpa?.outcome || slide.cpaOutcome) return true
      }
      const pageId = typeof slide === 'object' ? (slide._id || slide.id || slide.page || slide.pageId) : slide
      const questions = (this.session && this.session.questions) || (this.$store && this.$store.state && this.$store.state.session && this.$store.state.session.questions) || []
      const found = questions.find((q) => q.page === pageId || q.pageId === pageId || q.id === pageId || q._id === pageId)
      if (found) {
        return !!(found.cpa?.outcome || found.isCpa || found.cpaOutcome)
      }
      const pages = this.sessionPages || (this.session && this.session.pages) || (this.$store && this.$store.state && this.$store.state.sessionPages) || []
      const foundPage = pages.find((p) => p._id === pageId || p.id === pageId || p.page === pageId || p.pageId === pageId)
      if (foundPage) {
        return !!(foundPage.cpa?.outcome || foundPage.isCpa || foundPage.cpaOutcome)
      }
      return false
    },
    handleAcceptedStudentHelp(data) {
      if (!data) return
      this.measureDashHeader()
      if (data && data.channelStudents) {
        this.channelStudents = data.channelStudents
      }
      if (data && (data.activeStudentIdentity || data.identity)) {
        this.activeWhiteboardStudentIdentity = data.activeStudentIdentity || data.identity
      }
      let resolvedUrl = ''
      if (typeof data === 'string') {
        resolvedUrl = data
      } else if (data && typeof data === 'object') {
        if (data.cpaDrawUrl && data.cpaDrawUrl !== '/draw/') {
          resolvedUrl = data.cpaDrawUrl
        } else if (data.uid && data.slideId && data.sid && data.studentDrawKey) {
          resolvedUrl = `/draw/#room=${data.uid}_${data.slideId}_${data.sid},${data.studentDrawKey}`
        } else if (data.sid && data.studentDrawKey) {
          resolvedUrl = `/draw/#room=${data.sid},${data.studentDrawKey}`
        }
      }

      if (resolvedUrl && resolvedUrl !== '/draw/') {
        if (this.cpaDrawUrl !== resolvedUrl) {
          this.cpaDrawKey = Date.now()
          this.cpaDrawUrl = resolvedUrl
        }
        return
      }

      const slideId = (typeof data === 'object' && (data?.slideId || data?.questionId)) || this.currentPage?._id || (this.sessionPages && this.sessionPages[this.currentPageIndex]?._id)
      const isCpa = this.isCpaQuestion(slideId)
      if (!isCpa && !this.cpaDrawUrl) {
        this.cpaDrawUrl = ''
      }
    },
    handleChannelStudentsUpdated(data) {
      if (!data) return
      if (data.channelStudents) {
        this.channelStudents = data.channelStudents
      }
      if (data.activeStudentIdentity) {
        this.activeWhiteboardStudentIdentity = data.activeStudentIdentity
      }
      if (data.cpaDrawUrl && data.cpaDrawUrl !== '/draw/') {
        if (this.cpaDrawUrl !== data.cpaDrawUrl) {
          this.cpaDrawKey = Date.now()
          this.cpaDrawUrl = data.cpaDrawUrl
        }
      } else if (this.channelStudents.length === 0) {
        this.cpaDrawUrl = ''
        this.cpaDrawKey = 0
      }
    },
    selectWhiteboardTab(st) {
      if (!st || this.activeWhiteboardStudentIdentity === st.identity) return
      this.activeWhiteboardStudentIdentity = st.identity
      if (st.cpaDrawUrl && st.cpaDrawUrl !== '/draw/') {
        this.cpaDrawKey = Date.now()
        this.cpaDrawUrl = st.cpaDrawUrl
      }
      if (window.EventBus) {
        window.EventBus.$emit('teacher-switch-channel-tab', st)
      }
    },
    handleTeacherLeaveHelp(data) {
      if (!data || !data.participant || this.channelStudents.length <= 1) {
        this.cpaDrawUrl = ''
        this.cpaDrawKey = 0
        this.channelStudents = []
        this.activeWhiteboardStudentIdentity = ''
      }
    },
    closeWhiteboard() {
      this.cpaDrawUrl = ''
      this.cpaDrawKey = 0
      this.channelStudents = []
      this.activeWhiteboardStudentIdentity = ''
      if (window.EventBus) {
        window.EventBus.$emit('teacher-close-whiteboard')
        window.EventBus.$emit('teacher-left-help')
      }
    },
    measureDashHeader() {
      this.$nextTick(() => {
        const headerEl = document.querySelector('.dash-header-root .header') || document.querySelector('.header')
        if (headerEl) {
          const h = headerEl.offsetHeight || (headerEl.getBoundingClientRect && headerEl.getBoundingClientRect().height) || 74
          if (h > 0) {
            this.dashHeaderHeight = h
          }
        }
      })
    },
    onMeetingLeft() {
      this.$store.commit('setMeeting', {active: false, minimized: false, name: '', sid: '', audioMuted: true, videoMuted: true})
    },
    closeNewPrompt() {
      this.showNewPromptDialog = false
    },
    showNewPrompt() {
      this.showNewPromptDialog = true
    },
    addPPTItem(item) {
      if (item?.video) {
        location.reload()
      } else {
        this.$store.commit('patchSession', item)
        this.pageChange(parseInt(this.currentPageIndex) + 2)
        this.$store.dispatch('initMaterials')
        hideLoading()
      }
    },
    showInputDialog() {
      this.inputDialog = true
    },
    showDashTips() {
      this.dashTipsModalVisiable = !this.dashTipsModalVisiable
    },
    closeEvaluate() {
      this.drawerEvaluate = false
    },
    openEvaluate() {
      if (this.evaluationUrl) this.drawerEvaluate = true
    },
    // 检查token
    async initWithToken() {
      showLoading()
      if (!this.token) return this.goToLogin()
      const {logout, authentication, user} = await App.authenticate(
        {strategy: 'jwt', accessToken: this.token},
        {query: {sid: this.class_id, role: 'teacher'}}
      ).catch((err) => {
        return {logout: true}
      })
      if (logout) return this.goToLogin()
      if (authentication) {
        Acan.url('token', null)
        if (Acan.url('status') === 'student' && this.session.status !== 'student') {
          await this.$store.dispatch('upSession', {status: 'student'})
          Acan.url('status', null)
        }
      }
      this.name = window.currentNickname = user?.nickname
      window.uid = user?.email
      window.currentUserId = user?._id
      window.Auser = user
      window.class_id = this.class_id
      await Promise.all([this.initStudent(user), this.getAllSlides()])
      await this.$store.dispatch('initPageConf')
      setTimeout(() => {
        this.isInitOk = true
        if (this.$route.query.roster) {
          this.showStudents()
        }
        hideLoading()
      }, 100)
    },
    async guideOkCall() {
      this.isGuideOk = true
    },
    async guideCall() {
      if (this.isGuideOk) return
      await sleep(100)
      return this.guideCall()
    },
    goToLogin() {
      const url = `${hostUrl}/v2/login?from=roomTeacher&role=teacher&back=` + encodeURIComponent(location.origin + location.pathname)
      location.href = url
    },
    pageChange(value, notSend) {
      this.giveFocus(parseInt(value) - 1, notSend)
      if (this.showVideoPlayer) {
        this.closeVideoPlayer()
      }
      return
    },
    getPageData() {
      this.questionModalVisiable = false //与控制面板中的comment显示与否的按钮保持同步
      this.getItemData()
    },
    // 老师控制分页
    async sendPageControl() {
      App.service('auth').patch('syncTeacher', {commit: 'student/setCurrentPageIndex', data: this.currentPageIndex})
    },
    async getAllSlides() {
      // 初始化评论数据
      await Promise.all([
        App.service('comments')
          .find({query: {sid: this.class_id, $limit: 1000}})
          .then((rs) => {
            if (rs) this.setFeedBackList(rs.data)
            this.setFeedBackAnswerIds(rs.data.map((v) => v.rid))
          }),
        App.service('response')
          .find({query: {sid: this.class_id, $limit: 2000}})
          .then((rs) => {
            this.setAllAnswerdList(rs.data)
          }),
        this.$store.dispatch('initMaterials'),
      ])
      this.getItemData()
      this.session.pages?.map((o, i) => {
        this.responsePercentage[i] = 0
      })
      this.isFocus[this.currentPageIndex] = true
    },
    getItemData() {
      this.$nextTick(() => {
        if (!this.getQuestion) return
        this.getResponeCount()
      })
    },
    getCurrentVideoQuizAnswer() {
      let list = this.$store.state.student.allAnswerList.filter((item) => item.quizId === this.$store.state.student.currentVideoQuizId)
      return list
    },
    getCurrentPageAnswer() {
      const {type, page} = this.getQuestion
      let list = this.$store.state.student.allAnswerList.filter((item) => item.page === page)
      return list
      /*
      if (type !== 'comment') {
      } else {
        // comment remark 特殊，数据不在answer内
        let list = this.$store.state.remark.allRemarks.filter((item) => item.page_id === page_id)
        return list
      }*/
    },
    getResponeCount(f) {
      if (f || this.getQuestion) {
        const list = this.session?.video ? this.getCurrentVideoQuizAnswer() : this.getCurrentPageAnswer()

        this.currentAnswerCount = list.length
        this.responseContentList = list
        let count = 0
        let id = '-1'
        for (let i = 0; i < list.length; i++) {
          if (id != list[i].user_id) {
            count++
            id = list[i].user_id
          }
        }

        if (this.studentCounts < count) {
          this.studentCounts = count
        }
        if (count == 0) {
          this.responsePercentage[this.currentPageIndex] = 0
        } else {
          this.responsePercentage[this.currentPageIndex] = (count * 100) / this.studentCounts
        }
      } else {
        this.currentAnswerCount = 0
      }
    },
    copyUrl() {
      if (this.session.status === 'close') {
        this.showShareEvenClose = true
        if (!this.isMentorOrSubstitute) {
          this.$message.info({message: 'Please reopen session first', customClass: 'z-max'})
        }
      } else {
        this.$store.dispatch('upSession', {welcome: true})
      }
    },
    closeReopenDialog() {
      this.showReopenDialog = false
    },
    closeCopyDialog() {
      if (this.session.status === 'close' && this.showShareEvenClose) {
        this.showShareEvenClose = false
        return
      }
      if (this.session.welcome) this.$store.dispatch('upSession', {welcome: false})
      this.showWelcome()
    },
    showWelcome() {
      const welcomesetting = getStore('welcomesetting')
      if (!this.welcomeModalShowed && !this.isDashboard && !welcomesetting) {
        this.welcomeModalShowed = true
        this.welcomeModalVis = true
      }
    },
    hideWelcome() {
      this.welcomeModalVis = false
    },
    getBtnString() {
      if (this.$store.getters['teacher/onlineStudentCount'] == 0) {
        this.copyLinkBtnString = 'Waiting for students..'
      } else if (this.currentPageIndex == 0) {
        this.copyLinkBtnString = 'Start Class'
      } else {
        this.copyLinkBtnString = 'Continue'
      }
      return this.copyLinkBtnString
    },
    async turnModel() {
      if (this.session.status === 'student') {
        await this.$store.dispatch('upSession', {status: 'live'})
        this.sendModeChangeCommend()
      } else {
        this.showStudentPacedNotePage = true
      }
    },
    async confirmModeChange() {
      await this.$store.dispatch('upSession', {status: 'student'})
      this.sendModeChangeCommend()
      this.showStudentPacedNotePage = false
    },
    cancelModeChange() {
      this.showStudentPacedNotePage = false
    },
    sendModeChangeCommend() {
      if (this.session.status !== 'live') return
      // 如果从学生模式切换到老师模式，则通知学生进行页面切换操作
      this.sendPageControl()
      if (this.isMaterialShow) {
        //this.$route.name === 'd'
        this.$store.dispatch('syncTeacher', {commit: 'teacher/showPageMaterial', data: [this.currentPageIndex, this.getPageId]})
        this.$store.dispatch('syncTeacher', {commit: 'setMaterialSelect', to: 'teacher', data: this.$store.state.materialSelect})
      }
    },
    open() {
      var strWindowFeatures = 'width=1200,height=750,menubar=yes,resizable=yes,scrollbars=true,status=true,top=100,left=200'
      window.open(`/d/${this.class_id}?p=${this.currentPageIndex}`, '_blank', strWindowFeatures)
    },
    //重新开启课堂
    async _reopenClass() {
      //this.showReopenDialog = true
      await this.$store.dispatch('upSession', {status: 'live'})
      this.$message.info({message: 'Session reopened', customClass: 'z-max'})
    },
    //显示当前的学生
    async showStudents(tab) {
      showLoading()
      await this.$store.dispatch('getClassInfo')
      localStorage.setItem('RoomRoster:Tab', tab || 'student')
      hideLoading()
      this.showClassroomRoster = true
    },
    closeStudents() {
      this.showClassroomRoster = false
    },
    giveFocus(index, notSend) {
      if (isNaN(index)) return false
      if (this.currentPageIndex === index) return false
      if (index != this.currentPageIndex) {
        this.setStudentPageIndex(index)
        this.getResponeCount()
      }
      if (!notSend && this.session.status !== 'student') this.sendPageControl()
      for (let i = 0; i < this.getPageNum; i++) {
        this.isFocus[i] = i == index
      }
    },
    changeFeedbackTimeMode(index) {
      this.mode = index
    },
    backToClass() {
      location.href = hostUrl
    },

    async watchVideoClicked() {
      this.showVideoPlayer = true
      this.videoData = this.session.video[this.getPage._id]
      await App.service('auth').patch('syncTeacher', {commit: 'student/setWatchVideoClicked', data: true})
      await this.$store.dispatch('student/setWatchVideoClicked', true)
    },
    async closeVideoPlayer() {
      this.showVideoPlayer = false
      this.videoData = null
      await App.service('auth').patch('syncTeacher', {commit: 'student/setWatchVideoClicked', data: false})
      await this.$store.dispatch('student/setWatchVideoClicked', false)
    },
  },
}
</script>

<style lang="scss">
@import url(../assets/css/teacher.scss);
.popup-overlay {
  position: fixed;
  top: 50%;
  left: 50%;
  right: 0;
  bottom: 0;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  height: fit-content;
  transform: translate(-50%, -50%);
}

.popup-box {
  background: #fff;
  padding: 2rem;
  border-radius: 16px;
  max-width: 400px;
  text-align: center;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}

.watch-btn {
  background-color: #26a69a;
  color: white;
  border: none;
  padding: 0.8rem 1.5rem;
  border-radius: 20px;
  cursor: pointer;
  font-weight: 600;
  margin-top: 1rem;
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.watch-btn::before {
  content: '✔';
  font-size: 1rem;
  color: #fff;
}

::v-deep .classroom-roster-drawer,
::v-deep .el-drawer__wrapper:has(.classroom-roster-drawer) {
  z-index: 100002 !important;
}
</style>
